import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

const contactHeroBg =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop";

const HeroSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "600px",
        bgcolor: "#FCF9F8",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Absolute Positioned Content Box */}
      <Box
        sx={{
          position: "absolute",
          top: "48px",
          left: "30px", // Matched with card margin
          width: { xs: "calc(100% - 128px)", md: "896px" },
          height: { xs: "auto", md: "345px" },
          pt: "48px",
          pl: "32px", // Matched with card internal padding
          pr: { xs: "24px", md: "320px" },
          pb: "48px",
          bgcolor: "transparent",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start", // Strictly left-align items
          zIndex: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          style={{ width: "100%" }}
        >
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 600,
              color: "#FF5722",
              textTransform: "uppercase",
              letterSpacing: "1px",
              mb: 2,
              textAlign: "left", // Explicit left align
            }}
          >
            CONNECT WITH EXCELLENCE
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: 800,
              fontSize: { xs: "40px", md: "64px" },
              lineHeight: "1.1",
              color: "#1C1B1B",
              letterSpacing: "-2px",
              mb: 3,
              textAlign: "left", // Explicit left align
            }}
          >
            Let's shape your <br />
            <span style={{ color: "#FF5722" }}>architectural legacy.</span>
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "28px",
              color: "#57534E",
              maxWidth: "672px", // Fixed width as requested
              textAlign: "left",
            }}
          >
            Whether you're looking to acquire a signature property or discuss a
            bespoke development project, our advisors are here to provide
            tailored <br />
            expertise.
          </Typography>
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;
